import React from 'react';

const Logo = ({ onClick }) => {
  return (
    <div
      className="flex items-center space-x-3 cursor-pointer"
      onClick={onClick}
      title="Go to Home"
    >
      {/* Logo SVG */}
      <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-blue-600 rounded-lg flex items-center justify-center">
        <svg 
          className="w-6 h-6 text-white" 
          fill="currentColor" 
          viewBox="0 0 24 24"
        >
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      </div>
      
      {/* Title */}
      <div className="flex flex-col">
        <span className="text-xl font-bold text-gray-100">Enable.AI</span>
        <span className="text-xs text-gray-300 font-medium">AI Enablement Platform</span>
      </div>
    </div>
  );
};

export default Logo; 